module.exports = __webpack_public_path__ + "static/media/photo_18.d3bcee9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_18.jpg
// module id = 1651
// module chunks = 0